import { createSlice } from '@reduxjs/toolkit';

const sliderSlice = createSlice({
    name: 'slider',
    initialState: {
        opacity: '100%',
    },
    reducers: {
        changeOpacity: (state, action) => {
            state.opacity = action.payload;
        },
    },
});

export const { changeOpacity } = sliderSlice.actions;

export default sliderSlice.reducer;
